




















































































































import {Component, Ref, Vue} from 'vue-property-decorator';
import HomeOverView from './home-overview.vue';
import HomeShopView from './home-shop.vue';
import HomeCourseView from '@/views/official/home/home-course-view.vue';
import {HomeOver} from '@/static/home';

const Tactics = {
  /**nav数量*/
  navNumber: 6,
  /**初始化动画*/
  navInfo: function(target: HTMLElement) {
    let x = Tactics.navNumber * target.firstElementChild!.clientWidth;
    target.setAttribute('style', 'transform:translateX(' + x + 'px)');

    /**滚动条缓存*/
    let scrollTop = 0;
    let options = {
      root: document.getElementById('main'),
      rootMargin: `${target.firstElementChild!.clientHeight}px 0px ${target.firstElementChild!.clientHeight}px 0px`
    };

    /**滚动事件处理*/
    function scrollEvent(event: MouseEvent | any) {
      let target = event.target;
      scrollTop = scrollTop ? scrollTop - target.scrollTop : target.scrollTop;
    }


    /**展开动画*/
    function pull() {
      let event = arguments[0];
      let target = document.getElementById('nav-pc')!;
      let p: any = Array(/\d+/.exec(target.getAttribute('style')!))[0];
      if (p <= 50) {
        target.setAttribute('style', 'transform:translateX(0px)');
        document.getElementById('main')!.removeEventListener('scroll', pull, false);
      } else {
        scrollEvent(event); //事件处理
        target.setAttribute('style', `transform:translateX(${+p + scrollTop < 0 ? 0 : scrollTop / 1000}px)`);
      }
    }

    /**关闭动画*/
    function close() {
      let event = arguments[0];
      let target = document.getElementById('nav-pc')!;
      let p: any = Array(/\d+/.exec(target.getAttribute('style')!))[0];
      if (+p >= Tactics.navNumber * target.firstElementChild!.clientWidth - 50) {
        target.setAttribute('style', `transform:translateX(${Tactics.navNumber * target.firstElementChild!.clientWidth}px)`);
        document.getElementById('main')!.removeEventListener('scroll', close, false);
      } else {
        scrollEvent(event); //事件处理
        target.setAttribute('style', `transform:translateX(${+p + scrollTop < 0 ? 0 : scrollTop / 1000}px)`);
      }
    }

    //监听视图
    let observer = new IntersectionObserver((entries) => {
      let mainTarget = document.getElementById('main')!;
      entries.map((value) => {
        //顶部菜单监听
        if ([...value.target.classList].includes('app-nav')) {
          if (!value.isIntersecting) {    //离开
            console.log('pull');
            target.setAttribute('style', 'transform:translateX(' + x + 'px)');
            mainTarget.addEventListener('scroll', pull, false);
          } else {    //出现
            console.log('close');
            mainTarget.addEventListener('scroll', close, false);
          }
        }

      });
    }, options);
    observer.observe(document.querySelector('.app-nav')!);
  },
  /**返回顶部*/
  backTop: (show: boolean) => {
    let target = document.getElementById('back-top')!;
    target.setAttribute('style', `display: ${show ? 'flex' : 'none'};transition-delay: 1s;transition-property: display;`);
  },
  /**css动画*/
  navInfo2: function(): IntersectionObserver {
    // @ts-ignore
    let target = this.navPc;
    let x = Tactics.navNumber * target.firstElementChild!.clientWidth;
    target.setAttribute('style', 'transform:translateX(' + x + 'px)');
    let options = {
      root: null,
      threshold: .2,
      rootMargin: `${target.firstElementChild!.clientHeight}px 0px ${target.firstElementChild!.clientHeight}px 0px`
    };
    let observer = new IntersectionObserver((entries, obs) => {
      entries.map((value) => {
        //nav锚点导航css动画效果
        if ([...value.target.classList].includes('app-nav')) {
          if (!value.isIntersecting) {    //离开
            Tactics.backTop(true);
            target!.setAttribute('class', 'nav-list-pc');
            target.setAttribute('style', 'transform:translateX(0px);transition-duration: 1s;');
          } else {    //出现
            Tactics.backTop(false);
            target!.setAttribute('class', 'nav-list-pc');
            target.setAttribute('style', `transform:translateX(${x}px);transition-duration: 1s;`);
          }
        }
        if (value.isIntersecting) {
          //门店介绍监听
          if (value.target.id === 'home-shop') {
            // @ts-ignore
            this.anchor = 'home-shop';
          }
          //概述监听
          if (value.target.id === 'home-overview') {
            // @ts-ignore
            this.anchor = 'home-overview';
          }

          //课程监听
          if (value.target.id === 'home-course') {
            // @ts-ignore
            this.anchor = 'home-course';
          }
        }

      });
    }, options);
    observer.observe(document.querySelector('.app-nav')!);
    observer.observe(document.getElementById('home-overview')!);
    observer.observe(document.getElementById('home-shop')!);
    observer.observe(document.getElementById('home-course')!);
    return observer;
  }
};
@Component({
  components: {
    HomeCourseView,
    HomeOverView,
    HomeShopView
  }
})
export default class OfficialHomeView extends Vue {

  @Ref('nav-pc')
  private navPc!: HTMLElement;

  /**锚菜单*/
  private navItem: Array<any> = [
    {title: '课程', key: 'home-course'},
    {title: '概述', key: 'home-overview'},
    {title: '门店', key: 'home-shop'},
  ];

  /**锚点状态*/
  private anchor: string = 'home-overview';

  private intersectionObserver: IntersectionObserver | any;

  private branner: Array<string> = HomeOver.branner;

  async mounted() {
    this.intersectionObserver = Tactics.navInfo2.call(this);  //动画设置
  }

  /**销毁Observer监听*/
  destroyed() {
    this.intersectionObserver.disconnect();   //动画监听销毁
  }

  /**锚点跳转*/
  public onAnchorGo(key: string) {
    document.getElementById(key)!.scrollIntoView({
      behavior: 'smooth',
    });
  }


}
